import { makeAutoObservable, runInAction } from 'mobx';
import { getAllUsers } from 'services/user.services';
import { getListBarcodes, getListUnits } from 'services/list.services';

class ListStore {
  userList = [];
  barcodes = [];
  units = [];
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async init() {
    this.loading = true;
    try {
      const [users, barcodes, units] = await Promise.all([
        getAllUsers(),
        getListBarcodes(),
        getListUnits(),
      ]);

      runInAction(() => {
        this.userList = users;
        this.barcodes = barcodes;
        this.units = units;
        this.loading = false;
      });
    } catch (e) {
      runInAction(() => {
        this.loading = false;
      });
      console.error('Ошибка загрузки справочников:', e);
    }
  }
}

export const listStore = new ListStore();
